import { render, staticRenderFns } from "./BaseComment.vue?vue&type=template&id=4fc1156a&scoped=true&"
import script from "./BaseComment.vue?vue&type=script&lang=js&"
export * from "./BaseComment.vue?vue&type=script&lang=js&"
import style0 from "./BaseComment.vue?vue&type=style&index=0&id=4fc1156a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1156a",
  null
  
)

export default component.exports